import {components} from "../../../../api/interfaces/swagger-types";
export type LearnerMetrics = components["schemas"]["LearnerMetricsReportViewModel"]

export interface LearnerReports {
    learnerMetricsSignal: LearnerMetrics | null;
    learnerMetricsLoadingSignal: boolean;
  }
  
  export const learnerReportsInitialState: LearnerReports = {
    learnerMetricsSignal: null,
    learnerMetricsLoadingSignal: false,
  }


